const NCB_CONFIG = {
  instance: '53734_intellijungle',
  secretKey: '331d7caa5a54c4ff205cdb66288bf8ceffc14144165e44a48da6a2cfc05c',
  authUrl: 'https://app.nocodebackend.com/api/user-auth',
  dataUrl: 'https://app.nocodebackend.com/api/data',
};

// PARENT LOGIN
export async function signIn(email, password) {
  const cleanEmail = email.trim().toLowerCase();
  
  const res = await fetch(`${NCB_CONFIG.authUrl}/sign-in/email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Database-Instance': NCB_CONFIG.instance,
      'Authorization': `Bearer ${NCB_CONFIG.secretKey}`
    },
    body: JSON.stringify({ email: cleanEmail, password })
  });

  const data = await res.json();
  if (data.token && data.user) {
    localStorage.setItem('ncb_token', data.token);
    localStorage.setItem('ncb_user', JSON.stringify({ ...data.user, isParent: true }));
    localStorage.removeItem('active_kid');
    return data.user;
  }
  throw new Error(data.message || 'Login failed. Check your email and password!');
}

// KID LOGIN (Robust Name + Password Search)
export async function kidSignIn(name, password) {
  // 1. Clean the inputs: trim spaces and normalize case for the name
  const cleanName = name.trim();
  const cleanPassword = password.trim();

  // 2. Query the kids table. 
  // We use encodeURIComponent to handle names with special characters or spaces.
  const res = await writeFetch(`read/kids?name=${encodeURIComponent(cleanName)}&password=${encodeURIComponent(cleanPassword)}`);
  const result = await res.json();

  if (result.status === 'success' && result.data?.length > 0) {
    const kid = result.data[0];
    
    // 3. Store specialized session for the child
    const kidSession = { ...kid, isKid: true };
    localStorage.setItem('active_kid', JSON.stringify(kidSession));
    localStorage.removeItem('ncb_user'); // Safety: Log out parent if child logs in
    
    return kidSession;
  }
  
  throw new Error('Explorer Name or Password not found! (Names are case-sensitive)');
}

// PARENT SIGNUP
export async function signUp(email, password, name) {
  const cleanEmail = email.trim().toLowerCase();
  const cleanName = name.trim();

  const res = await fetch(`${NCB_CONFIG.authUrl}/sign-up/email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Database-Instance': NCB_CONFIG.instance,
      'Authorization': `Bearer ${NCB_CONFIG.secretKey}`
    },
    body: JSON.stringify({ email: cleanEmail, password, name: cleanName })
  });

  const data = await res.json();
  if (data.token && data.user) {
    localStorage.setItem('ncb_token', data.token);
    localStorage.setItem('ncb_user', JSON.stringify({ ...data.user, isParent: true }));
    return data.user;
  }
  throw new Error(data.message || 'Signup failed. Email might already be in use.');
}

// DATA FETCH WRAPPER (USES SECRET KEY)
export async function writeFetch(path, options = {}) {
  const separator = path.includes('?') ? '&' : '?';
  const url = `${NCB_CONFIG.dataUrl}/${path}${separator}Instance=${NCB_CONFIG.instance}`;

  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${NCB_CONFIG.secretKey}`,
      'X-Database-Instance': NCB_CONFIG.instance,
      ...options.headers,
    },
  });
}

// SESSION HELPER
export function getSession() {
  const kid = localStorage.getItem('active_kid');
  if (kid) return JSON.parse(kid);
  
  const parent = localStorage.getItem('ncb_user');
  return parent ? JSON.parse(parent) : null;
}

// LOGOUT HELPER
export function logout() {
  localStorage.removeItem('ncb_token');
  localStorage.removeItem('ncb_user');
  localStorage.removeItem('active_kid');
}